import React from "react"
import { useAdertisementData } from "./utils"

export const MobileInterscroller = ({
  ressort = "baumagazin",
  tags,
  topic,
}) => {
  const adbutlerIds = {
    baumagazin: 534744,
    galabau: 534746,
    umweltbau: 534745,
  }

  const state = useAdertisementData({
    set_id: adbutlerIds[ressort],
    max_width: 1024,
    ressort,
    tags,
    topic,
  })
  const {
    body,
    imageURL,
    imageWidth,
    imageHeight,
    link_target,
    redirectURL,
    tracking_pixel,
  } = state

  return (
    <React.Fragment>
      {!!body || !!imageURL ? (
        <div data-nosnippet className="is-hidden-desktop mb-5 mt-3">
          <div className="help has-text-centered has-background-grey-lighter">
            Anzeige
          </div>
          <div
            style={{
              width: "100%",
              height: "80vh",
              overflow: "hidden",
              clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            }}
          >
            {body ? (
              <div>
                <div
                  style={{
                    position: "fixed",
                    top: "10%",
                    left: 0,
                    right: 0,
                    margin: "auto",
                  }}
                  dangerouslySetInnerHTML={{ __html: body }}
                ></div>
              </div>
            ) : imageURL ? (
              <div>
                <a
                  href={redirectURL}
                  target={link_target}
                  rel="noopener noreferrer"
                  title={`Anzeige`}
                >
                  <img
                    src={imageURL}
                    alt={`Anzeige`}
                    title={`Anzeige`}
                    width={imageWidth || "auto"}
                    height={imageHeight || "auto"}
                    style={{
                      position: "fixed",
                      maxHeight: "90%",
                      width: "auto",
                      top: "15%",
                      left: 0,
                      right: 0,
                      margin: "auto",
                    }}
                  />
                </a>
              </div>
            ) : null}
          </div>
          {!!tracking_pixel ? (
            <div className="has-text-centered mt-2">
              <a href={redirectURL} aria-label="pxl">
                <img
                  src={tracking_pixel}
                  alt=""
                  style={{ maxWidth: 350, maxHeight: 70 }}
                />
              </a>
            </div>
          ) : null}
          <div className="help has-background-grey-lighter mt-0">&nbsp;</div>
        </div>
      ) : null}
    </React.Fragment>
  )
}
